<template>
  <div class="row py-2 align-items-center" v-bind:class="{ 'tr-red': !checked, 'tr-green': checked }">
    <div class="col-md-1">
      <vue-timepicker input-width="100%" auto-scroll manual-input v-model="fromTime" format="HH:mm" :minute-interval="15"
        close-on-complete></vue-timepicker>
    </div>
    <div class="col-md-1">
      <vue-timepicker input-width="100%" auto-scroll manual-input v-model="toTime" format="HH:mm" :minute-interval="15"
        close-on-complete></vue-timepicker>
    </div>
    <div class="col-md-2">
      <template v-if="this.projects">
        <select v-on:change="onChangeProject" v-model="hour.azureDevOpsId" class="form-control form-control-sm">
          <option v-for="project in this.projects" v-bind:value="project.id" v-bind:key="project.id">
            <template>
              {{ project.title }}
            </template>
          </option>
        </select>
      </template>
    </div>
    <div class="col-md-1">
      <template v-bind:disabled="this.azureTasks">
        <select v-on:change="onChangeAzureTasks" v-model="hour.task" class="form-control form-control-sm"
          v-bind:disabled="!hour.azureDevOpsId">
          <option v-for="task in this.azureTasks" v-bind:value="task.id" v-bind:key="task.id">
            <template>
              {{ task.id }}
            </template>
          </option>
        </select>
      </template>
    </div>
    <div class="col-md-2 pl-4">
      <template>
        <p class="mb-0"> {{ hour.taskTitle }}</p>
      </template>
    </div>
    <div class="col-md-1">
      <template v-if="hour.task">
        <input v-model="hour.payer" size="5" class="form-control form-control-sm" disabled="disabled" />
      </template>
    </div>
    <div class="col-md-2">
      <textarea @input="onChangeComment" v-model="hour.comment" class="form-control form-control-sm"></textarea>
    </div>
    <div class="col-md-1">
      <select @change="onChangeStatus" v-model="hour.status" class="form-control form-control-sm">
        <option v-for="status in taskStatus" v-bind:key="status">
          {{ status }}
        </option>
      </select>
    </div>
    <div class="col-md-1">
      <a class="btn btn-danger btn-sm mr-4 mt-1" @click="deleteHour" style="width: 80px;">
        Löschen</a>
      <a class="btn btn-success btn-sm mt-1" @click="submitHour" style="width: 80px;">
        Submit</a>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "hourRow",
  props: ["hours", "hour", "date", "projects", "azureProjects", "azureConnection"],
  data: function () {
    return {
      fromTime: moment(this.hour.from).format("HH:mm"),
      toTime: moment(this.hour.to).format("HH:mm"),
      checked: true,
      waitingForInitialPost: false,
      azureTasks: null,
      azureSelectedTask: "",
      azureSelectedProject: "",
      taskStatus: [
        "None",
        "In Progress",
        "Completed",
        "Completed & Tested",
        "Released",
      ],
    };
  },
  created: function () { },
  mounted: async function () { },
  updated: function () { },

  // vue js lifecycle hook
  beforeUpdate: async function () {

    const projectSelected = await this.getProjectObject(
      this.hour.azureDevOpsId
    );

    if (projectSelected) {
      this.azureSelectedProject = projectSelected.title;
      if (this.azureTasks == null) {
        // this condition here stops continuous fetching and rendering
        await this.getProjectTasks(this.azureSelectedProject);
      }
    }
  },
  methods: {
    /**
     * Summary: fetch Azure Project's Tasks array.
     * @param azureProjectTitle
    */
    getProjectTasks: async function (projectTitle) {
      try {
        // check azure repeated api calls, prevent multiple calls
        const tasks = await this.azureConnection.getQueryByWiql(projectTitle);
        this.azureTasks = tasks.workItems;
        console.log("hourRow: getProjectTasks() called", tasks);

      } catch (error) {
        console.log(error);
      }
    },
    onChangeAzureTasks: function (event) {
      this.azureSelectedTask = event.target.value;
      this.checked = false;
      this.getTaskBilled();
    },
    onChangeStatus: function (event) {
      this.checked = false;
    },
    /**
     * Summary: fetch Azure Project by Project ID.
     * @param azureProjectId
    */
    getProjectObject: function (id) {
      const project = this.projects.find(
        (element) => element.id == id
      );
      return project;
    },
    onChangeProject: function (event) {
      const project = this.getProjectObject(event.target.value);
      this.hour.projectId = project.id;
      this.azureTasks = null;
      this.getProjectTasks(project.title);
      this.azureSelectedProject = project.title;
      this.checked = false;
    },
    onChangeComment: function (event) {
      this.checked = false;
    },
    submitHour: function (event) {

      var dateParam = moment(this.$route.query.date).format('YYYY-MM-DD');
      var date = moment(this.date).format('YYYY-MM-DD');

      if (dateParam == date) {
        this.checked = false;
        var from = this.date + " " + this.fromTime;
        var to = this.date + " " + this.toTime

        // check if hours are overlapping
        if (this.isTimeRangeOverlapping(from, to, this.hour.id)) {
          alert('Time range overlaps with an existing entry. Please adjust the time range.');
          return;
        }

        if (!this.isProjectSelected()) {
          alert('Please select a project.');
          return;
        }

        this.hour.to = to;
        this.hour.from = from;
        var compareTimeFrom = moment(this.hour.from);
        var compareTimeTo = moment(this.hour.to);

        if (compareTimeFrom >= compareTimeTo) {
          alert("Fehler: Die 'Von' Zeit muss früher sein als die 'Bis' Zeit.");
          return;
        }

        this.waitingForInitialPost = true;

        axios({
          method: "PUT",
          url: process.env.VUE_APP_API_PATH + "hours/" + this.hour.id,
          data: this.hour,
        }).then(
          (result) => {
            //Changes have been saved
            this.$emit("replaceHour", this.hour.id, result.data);
            this.checked = true;
            this.$emit(
              "setHighestDayHour",
              moment(this.hour.to).format("HH:mm")
            );
          },
          (error) => {
            //Changes have not been saved
            //console.error(error);
            this.checked = false;
          }
        );

      } else {
        alert("Fehler: Datum stimmt nicht überein, Seite bitte aktualisieren.");
      }
    },

    isProjectSelected() {
      console.log('isProjectSelected', this.hour.projectId);
      return this.hour.projectId != 0 && this.hour.projectId !== null && this.hour.projectId !== undefined;
    },

    isTimeRangeOverlapping(givenFrom, givenTo, excludedId) {
      const from = moment(givenFrom);
      const to = moment(givenTo);

      console.log('isTimeRangeOverlapping', from.format('YYYY-MM-DD HH:mm'), to.format('YYYY-MM-DD HH:mm'));
      console.log('excludedId', excludedId);
      
      for (const existingHour of this.hours) {
        // Skip the hour with the same id as excludedId
        if (existingHour.id === excludedId) {
          continue;
        }

        const existingFrom = moment(existingHour.from);
        const existingTo = moment(existingHour.to);

        console.log('existing hours', existingFrom.format('YYYY-MM-DD HH:mm'), existingTo.format('YYYY-MM-DD HH:mm'));

        // Check for overlap
        if (
          from.isBetween(existingFrom, existingTo, null, '[)') || // givenFrom is within the existing range (inclusive of existingFrom, exclusive of existingTo)
          to.isBetween(existingFrom, existingTo, null, '(]') || // givenTo is within the existing range (exclusive of existingFrom, inclusive of existingTo)
          (from.isSameOrBefore(existingFrom) && to.isSameOrAfter(existingTo)) // given range completely overlaps the existing range
        ) {
          return true;
        }
      }

      return false;
    },



    deleteHour: function (event) {
      if (this.hour.id < 0) {
        //Delete locally
        this.$emit("deleteHour", this.hour.id);
      } else {
        //Send to server
        axios({
          method: "DELETE",
          url: process.env.VUE_APP_API_PATH + "hours/" + this.hour.id,
        }).then(
          (result) => {
            //Notify parent that specific id has been removed
            this.$emit("deleteHour", result.data.id);
          },
          (error) => {
            console.error(error);
          }
        );
      }
    },

    getTaskBilled: async function (event) {
      this.hour.payer = null;
      this.hour.taskTitle = null;
      axios({
        method: "GET",
        url: "https://netzlab.visualstudio.com/_apis/wit/workItems/" + this.hour.task,
        headers: {
          'Authorization': `Basic QmFzaWM6ZzNianpiZXVlazVpZ2x4cnZkbTd3bzV5N3BpaXNmYnR3YXN0NHlhb2JheHJzeHQ0Y29icQ==`
        },
      }).then(
        (result) => {
          //Notify parent that specific id has been removed
          console.log(result.data['fields']['Custom.Billed'])
          this.hour.payer = result.data['fields']['Custom.Billed'];
          this.hour.taskTitle = result.data['fields']['System.Title'];
          console.log(result.data['fields']['System.Title'])

        },
        (error) => {
          console.error(error);
        }
      );
    },
  },
};
</script>
